import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import Check from '@mui/icons-material/Check';
import Clear from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import CloseButton from '../ui/CloseButton.tsx';
import PaperComponent from '../PaperComponent';

import api from '../../utils/api.ts';
import {
  setAlertsSnackbarOpen,
  setAlertsSnackbarSeverity,
  setAlertsSnackbarText,
} from '../../features/app/alertsSnackbarSlice';
import { removeUserEventByUuid } from '../../features/events/userEventsSlice';

import { useTranslation } from 'react-i18next';

import { borderedDialogPaperProps } from '../../theme';

import { setConfirmDeleteEventDialogOpen } from '../../features/dialogs/confirmDeleteEventDialogSlice';
import { setEventDialogOpen } from '../../features/dialogs/eventDialogSlice';

export default function ConfirmDeleteEventDialog() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(false);

  const open = useSelector((state) => state.confirmDeleteEventDialog.open);
  const event = useSelector((state) => state.confirmDeleteEventDialog.event);

  const handleClose = () => {
    dispatch(setConfirmDeleteEventDialogOpen(false));
  };

  const handleDelete = async () => {
    if (deleteButtonDisabled) { return };
    setDeleteButtonDisabled(true);
    const data = { uuid: event.properties.uuid };

    await api.delete('/events/delete/', { 'data': data }).then(response => {
      dispatch(setAlertsSnackbarSeverity('info'));
      dispatch(setAlertsSnackbarText(t('Event removed')));
      dispatch(setAlertsSnackbarOpen(true));
      dispatch(removeUserEventByUuid(event.properties.uuid));
      dispatch(setEventDialogOpen(false));

      handleClose();
      setTimeout(() => { setDeleteButtonDisabled(false) }, 1000);
    }).catch(err => {
      dispatch(setAlertsSnackbarSeverity('error'));
      dispatch(setAlertsSnackbarText(t('Something went wrong.')));
      dispatch(setAlertsSnackbarOpen(true));

      setTimeout(() => {
        setDeleteButtonDisabled(false);
      }, 1500);
    });
  };

  useEffect(() => {
    if (!open) setDeleteButtonDisabled(false);
  }, [open]);

  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      hideBackdrop={false}
      aria-labelledby="draggable-dialog-title"
      aria-describedby="alert-dialog-description"
      {...borderedDialogPaperProps}
    >
      <DialogTitle textAlign="center" style={{ cursor: 'move' }} id="draggable-dialog-title">
        {t('Confirm delete')}
      </DialogTitle>
      <CloseButton onClick={handleClose} />
      <form>
        <DialogContent>
          <Typography>
          </Typography>
          <DialogContentText id="alert-dialog-description">
            {t('Are you sure you want to delete')} <strong>{event.properties?.name}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="outlined"
            startIcon={<Clear />}
            onClick={handleClose}>
            {t('Cancel')}
          </Button>
          <Button
            disabled={deleteButtonDisabled}
            onClick={handleDelete}
            variant="outlined"
            endIcon={<Check />}
            color="error"
          >
            {t('Delete')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
};